export default "__VITE_ASSET__DdHX3SQw__"